import React, { FC } from 'react';
import { IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import { Person } from '@mui/icons-material';
import ReviewText from '../ReviewText';
import DataShakeSummary from '../DataShakeSummary';

interface Props extends IReviewNewProps {}

const TrustPilotReview: FC<Props> = ({
  commentingModule,
  communityManagement,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { username, title, text, rating, reviewLink, url, companyComment } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      reviewLink={reviewLink || url}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {title ? (
        <>
          {username && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: theme.palette.text.secondary,
              }}
            >
              <Person fontSize="small" />
              <Typography
                variant="body1"
                sx={{ ml: theme.spacing(1) }}
              >
                {username}
              </Typography>
            </Box>
          )}
          {title && (
            <Typography
              variant="h6"
              sx={{
                mt: theme.spacing(2),
              }}
            >
              {title}
            </Typography>
          )}
          <ReviewText text={text} />
        </>
      ) : (
        <DataShakeSummary reviewEntry={reviewEntry} />
      )}
    </ReviewWrapper>
  );
};

export default TrustPilotReview;
